'use strict';

// Class definition
var KTChartsWidget42 = (function () {
  var chart = {
    self: null,
    rendered: false,
  };

  // Private methods
  var initChart = function (chart) {
    var element = document.getElementById('kt_charts_widget_42');

    if (!element) {
      return;
    }

    var height = parseInt(KTUtil.css(element, 'height'));
    var labelColor = KTUtil.getCssVariableValue('--bs-gray-500');
    var borderColor = KTUtil.getCssVariableValue('--bs-border-dashed-color');
    var baseprimaryColor = KTUtil.getCssVariableValue('--bs-primary');
    var basesuccessColor = KTUtil.getCssVariableValue('--bs-success');

    var options = {
      series: [
        {
          name: 'Inbound Calls',
          data: [45, 80, 53, 80, 75, 100, 76, 117, 76, 110, 70, 112],
        },
      ],
      chart: {
        fontFamily: 'inherit',
        type: 'area',
        height: height,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {},
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        show: true,
        width: 3,
        colors: [baseprimaryColor, basesuccessColor],
      },
      xaxis: {
        categories: [
          '',
          '29 Sep',
          '1 Aug',
          '2 Aug',
          '3 Aug',
          '4 Aug',
          '5 Aug',
          '6 Aug',
          '7 Aug',
          '8 Aug',
          '9 Aug',
          '10 Aug',
          '11 Aug',
          '12 Aug',
          '13 Aug',
          '14 Aug',
          '15 Aug',
          '16 Aug',
          '',
        ],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tickAmount: 6,
        labels: {
          rotate: 0,
          rotateAlways: true,
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: [baseprimaryColor, basesuccessColor],
            width: 1,
            dashArray: 3,
          },
        },
        tooltip: {
          enabled: true,
          formatter: undefined,
          offsetY: 0,
          style: {
            fontSize: '12px',
          },
        },
      },
      yaxis: {
        max: 120,
        min: 30,
        tickAmount: 6,
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        hover: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: '12px',
        },
      },
      colors: [baseprimaryColor, basesuccessColor],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      markers: {
        strokeColor: [baseprimaryColor, basesuccessColor],
        strokeWidth: 3,
      },
    };

    chart.self = new ApexCharts(element, options);

    // Set timeout to properly get the parent elements width
    setTimeout(function () {
      chart.self.render();
      chart.rendered = true;
    }, 200);
  };

  // Public methods
  return {
    init: function () {
      initChart(chart);

      // Update chart on theme mode change
      KTThemeMode.on('kt.thememode.change', function () {
        if (chart.rendered) {
          chart.self.destroy();
        }

        initChart(chart);
      });
    },
  };
})();

// Webpack support
if (typeof module !== 'undefined') {
  module.exports = KTChartsWidget42;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTChartsWidget42.init();
});
